import { render, staticRenderFns } from "./Offercategories.vue?vue&type=template&id=6ac281b3&scoped=true&"
import script from "./Offercategories.vue?vue&type=script&lang=js&"
export * from "./Offercategories.vue?vue&type=script&lang=js&"
import style0 from "./Offercategories.vue?vue&type=style&index=0&id=6ac281b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac281b3",
  null
  
)

export default component.exports